enum HomeStatus {
  planning = 'Planning',
  fully_planned = 'Fully Planned',
  on_market = 'On the Market',
  sold = 'Sold',
}

export default HomeStatus;
